import { bindEvents, lodash, splitTextDoubleWrap } from '../../../assets/js/helpers';

import ResizeController from '../../../assets/js/controller/resize';

import SplitText from '../../../assets/js/plugins/SplitText';

const selector = 'text-animated';

export default class TextAnimated {

	constructor(section) {
		this.el = {
			section,
			paragraphs: section.querySelectorAll('p')
		};

		// class variable groups

		this.controllers = {
			resize: null
		};

		this.throttled = {
			resize: lodash.throttle(this.measureResize.bind(this), 500, { leading: false, trailing: true })
		};

		this.splits = [];

		// bind events to class scope
		this.events = bindEvents(this);

		// let's mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize

	init() {
		this.measureResize();
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.events._onWindowResize(); },
			resize: () => {}
		});
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	_onWindowResize() {
		this.throttled.resize();
	}

	//

	measureResize() {
		for (let i = 0; i < this.splits.length; i++) {
			const split = this.splits[i];
			split.revert();
		}

		this.splits = [];

		const configParam = this.el.section.getAttribute('data-text-animated') || '';
		const config = {
			chars: configParam.indexOf('chars') >= 0,
			words: configParam.indexOf('words') >= 0,
			lines: configParam.indexOf('lines') >= 0
		};

		let splitType = [];
		if (config.chars) { splitType.push('chars'); }
		if (config.words) { splitType.push('words'); }
		if (config.lines) { splitType.push('lines'); }
		splitType = splitType.join(',');

		if (splitType.length) {
			if (this.el.paragraphs.length) {
				for (let i = 0; i < this.el.paragraphs.length; i++) {
					const $p = this.el.paragraphs[i];
					const split = new SplitText($p, { type: splitType, linesClass: 'line' });
					this.splits.push(split);
					splitTextDoubleWrap(split, true, false);
				}
			} else {
				const split = new SplitText(this.el.section, { type: splitType, linesClass: 'line' });
				this.splits.push(split);
				splitTextDoubleWrap(split, true, false);
			}
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
